import service from '@/plugins/service'

const base = 'device'
const protocolBase = 'device/protocol'

export const copyProtocol = params => {
  return service({
    url: `${protocolBase}/copy`,
    method: 'POST',
    params
  })
}

export const searchProtocolCode = (current, pageSize, protocolCode, protocolName) => {
  return service({
    url: `${base}/protocol`,
    method: 'GET',
    params: {
      current,
      pageSize,
      protocolCode,
      protocolName
    }
  })
}

export const getProtocolList = (current, pageSize, protocolCode, protocolName) => {
  return service({
    url: `${protocolBase}`,
    method: 'GET',
    params: {
      current,
      pageSize,
      protocolCode,
      protocolName
    }
  })
}

export const addProtocol = data => {
  return service({
    url: `${protocolBase}`,
    method: 'POST',
    data
  })
}

export const updateProtocol = data => {
  return service({
    url: `${protocolBase}`,
    method: 'PUT',
    data
  })
}

export const getProtocol = code => {
  return service({
    url: `${protocolBase}`,
    method: 'GET',
    params: {
      code
    }
  })
}

export const deleteProtocol = codes => {
  let queryParams = ''
  codes.forEach(code => {
    queryParams += 'code=' + code + '&'
  })
  queryParams = queryParams.slice(0, -1)

  return service({
    url: `${protocolBase}?${queryParams}`,
    method: 'DELETE'
  })
}

export const syncProtocol = protocolCode => {
  return service({
    url: `${protocolBase}/sync`,
    method: 'PUT',
    params: {
      protocolCode
    }
  })
}

export const importProtocl = file => {
  const formData = new FormData()
  formData.append('file', file)

  return service({
    url: `${protocolBase}/import`,
    method: 'POST',
    data: formData
  })
}
